module.exports = __webpack_public_path__ + "static/FoundersGrotesk-Regular-6615aadc50b310d9e5bd3e9cedc4ba19.svg";